/** Phosphor Duotone, MIT; original SVG files and license live alongside the assets. */
export type ProfileIconName =
  | 'pencil-simple'
  | 'envelope-simple'
  | 'sliders-horizontal'
  | 'chart-bar'
  | 'users-three'
  | 'compass'
  | 'sword'
  | 'medal';

export function ProfileIcon({
  name,
  size = 22,
}: {
  readonly name: ProfileIconName;
  readonly size?: number;
}): React.ReactElement {
  return (
    <img
      className="profile-icon"
      src={`/art/profile/icons/${name}.svg?v=2`}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}
